import
{
  CALL_TOKEN_LAUDASA,
  CALL_TOKEN_CHROMATOX,
  CALL_CREDENTIALS_SHOPPING_CENTRAL
} from '../types'
import externalTokensService from '@/api/token'
import { stripCnpjMask } from '@/utils/cnpj-utils'

const state = {
  tokenLaudasa: '',
  tokenChromatox: '',
  shoppingCentralCredentials: ''
}

const mutations = {
  [CALL_TOKEN_LAUDASA] (state, value) {
    state.tokenLaudasa = value
  },
  [CALL_TOKEN_CHROMATOX] (state, value) {
    state.tokenChromatox = value
  },
  [CALL_CREDENTIALS_SHOPPING_CENTRAL] (state, value) {
    state.shoppingCentralCredentials = value
  }
}

const getters = {
  laudasaToken: (state) => {
    return state.tokenLaudasa
  },
  chromatoxToken: (state) => {
    return state.tokenChromatox
  },
  shoppingCentralCredentials: (state) => {
    return state.shoppingCentralCredentials
  }
}

const actions = {
  callServiceTokenLaudasa: function ({ commit }) {
    return externalTokensService.callTokenLaudasaService().then(
      function (response) {
        if (response.status === 200) {
          commit(CALL_TOKEN_LAUDASA, response.data.token)
        }
      }
    )
  },
  callServiceTokenChromatox: function ({ commit }) {
    return externalTokensService.callTokenChromatoxService().then(
      function (response) {
        if (response.status === 200) {
          commit(CALL_TOKEN_CHROMATOX, response.data.token)
        }
      }
    )
  },
  callServiceShoppingCentralCredentials: function ({ commit, rootState }) {
    if (rootState && rootState.authentication.profile.laboratoryCnpj) {
      const cnpj = stripCnpjMask(rootState.authentication.profile.laboratoryCnpj)
      const key = cnpj.substring(0, 4) + cnpj.substring(cnpj.length - 4, cnpj.length)
      commit(CALL_CREDENTIALS_SHOPPING_CENTRAL, { cnpj: cnpj, key: key })
    } else {
      commit(CALL_CREDENTIALS_SHOPPING_CENTRAL, { cnpj: null, key: null })
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
export
{
  mutations,
  actions,
  getters
}
